import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmergencyManagementService {

  getAllPatientsUrl: string = 'api/AdminMedicalCard/GetAllPatients';
  searchPatientsUrl: string = 'api/AdminMedicalCard/SearchForPatients';
  changePatientActivationStatusUrl: string = 'api/AdminMedicalCard/ChangePatientActivationStatus?phoneNumber=';
  constructor(private http: HttpClient) { }
  getAllPatients(pageSize: number, currentPage: number) {
    return this.http.get(`${this.getAllPatientsUrl}?currentPage=${currentPage}&pageSize=${pageSize}`);
  }
  searchLcaPatient(phoneNumber, pageSize, currentPage) {
    return this.http.get(`${this.searchPatientsUrl}?currentPage=${currentPage}&pageSize=${pageSize}&phoneNumber=${phoneNumber}`);
  }

  changePatientActivationStatus(phoneNumber: string) {
    return this.http.get(`${this.changePatientActivationStatusUrl}${phoneNumber}`);
  }
}
